module.exports = __webpack_public_path__ + "img/f2@2x.3f84bc30.png";